import { useNavigate } from "react-router-dom";
import { QUICK_ACTIONS, MODULES } from "@shared/modules.ts";
import { useBrands } from "../lib/brand.tsx";
import { useAuth } from "../lib/auth.tsx";
import { Icon } from "../lib/icons.tsx";

export default function Dashboard() {
  const nav = useNavigate();
  const { activeBrand, brands } = useBrands();
  const { user } = useAuth();

  return (
    <div className="page">
      <div className="page__head">
        <div className="page__title">สวัสดี {user?.name} 👋</div>
        <div className="page__subtitle" style={{ fontSize: 20, color: "var(--text-primary)", fontWeight: 700, marginTop: 10 }}>
          วันนี้อยากให้ AI ช่วยอะไร?
        </div>
        <div className="mh-sec" style={{ marginTop: 4 }}>
          {activeBrand
            ? <>กำลังทำงานในบริบทแบรนด์ <b>{activeBrand.name}</b> — เลือกสิ่งที่ต้องการด้านล่าง</>
            : brands.length === 0
              ? <>เริ่มต้นด้วยการสร้างแบรนด์แรกของคุณ เพื่อให้ AI เข้าใจบริบทก่อนช่วยงาน</>
              : <>เลือกแบรนด์จากมุมขวาบน เพื่อให้ AI ทำงานตรงบริบท</>}
        </div>
      </div>

      {brands.length === 0 && (
        <div className="mh-card card-pad" style={{ marginBottom: 22, display: "flex", gap: 16, alignItems: "center", borderColor: "var(--blue-100)", background: "var(--blue-050)" }}>
          <div className="qa__icon"><Icon name="Building2" /></div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700 }}>ยังไม่มีแบรนด์</div>
            <div className="mh-sec" style={{ fontSize: 14 }}>สร้าง Sooksabay Online, McAlive หรือแบรนด์ลูกค้า เพื่อเก็บ Brand Brain</div>
          </div>
          <button className="mh-btn mh-btn--primary" onClick={() => nav("/brands")}><Icon name="Plus" size={18} /> สร้างแบรนด์</button>
        </div>
      )}

      <h2 style={{ fontSize: 16, margin: "8px 0 14px" }}>เริ่มงานด่วน (Quick Actions)</h2>
      <div className="qa-grid">
        {QUICK_ACTIONS.map((a, i) => (
          <button className="qa" key={i} onClick={() => nav(a.path)}>
            <span className="qa__icon"><Icon name={a.icon} /></span>
            <span>
              <span className="qa__label">{a.label}</span>
              <br />
              <span className="qa__en">{a.en}</span>
            </span>
          </button>
        ))}
      </div>

      <h2 style={{ fontSize: 16, margin: "30px 0 14px" }}>สถานะการพัฒนา (Milestones)</h2>
      <div className="cards">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((ms) => {
          const items = MODULES.filter((m) => m.milestone === ms);
          if (!items.length) return null;
          const ready = items.every((m) => m.status === "ready");
          return (
            <div className="mh-card card-pad" key={ms}>
              <div className="mh-spread">
                <b>Milestone {ms}</b>
                <span className={"mh-pill " + (ready ? "mh-pill--winner" : "mh-pill--testing")}>
                  {ready ? "พร้อมใช้" : "กำลังพัฒนา"}
                </span>
              </div>
              <div className="mh-sec" style={{ fontSize: 13, marginTop: 8 }}>
                {items.map((m) => m.label).join(" · ")}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
